import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/apps/front/src/layouts/default.vue").then(m => m.default || m)),
  discover: defineAsyncComponent(() => import("/vercel/path0/apps/front/src/layouts/discover.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/vercel/path0/apps/front/src/layouts/home.vue").then(m => m.default || m))
}